import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'react-qr-code';

const QRCodeViewer = ({
  value,
  size = 256,
  enlargeText = "Увеличить код",
  scanText = "Отсканируйте QR-код",
  enlargedSize = 320,
  className = ""
}) => {
  const [isEnlarged, setIsEnlarged] = useState(false);

  const handleEnlarge = (e) => {
    e.preventDefault();
    setIsEnlarged(true);
  };

  const handleClose = () => {
    setIsEnlarged(false);
  };

  if (!value) return null;

  const enlargedOverlay = isEnlarged && (
    <div
      className="qr-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        cursor: 'pointer'
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          transform: isEnlarged ? 'scale(1)' : 'scale(0.8)',
          transition: 'transform 0.2s ease-in-out',
          cursor: 'default'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '5px',
            right: '10px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#666'
          }}
        >
          ×
        </button>
        <QRCode
          value={value}
          size={enlargedSize}
          level="H"
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
    </div>
  );

  return (
    <div className={`qr-code-viewer ${className}`}>
      <QRCode
        value={value}
        size={size}
        level="H"
        bgColor="#ffffff"
        fgColor="#000000"
      />
      <div style={{ marginTop: '10px' }}>
        <a href="#" onClick={handleEnlarge} style={{ color: '#1890ff' }}>
          {enlargeText}
        </a>
      </div>
      <div style={{ marginTop: '10px', color: '#666' }}>
        {scanText}
      </div>

      {enlargedOverlay && createPortal(enlargedOverlay, document.body)}
    </div>
  );
};

export default QRCodeViewer;
